// extracted by mini-css-extract-plugin
export var card = "_nb-0";
export var content = "_nb-2";
export var details = "_nb-3";
export var icon = "_nb-1";
export var iconBlue = "_nb-5";
export var iconBrand = "_nb-4";
export var iconGrayBlue = "_nb-6";
export var iconGreen = "_nb-7";
export var iconIndigo = "_nb-8";
export var iconOrange = "_nb-9";
export var iconPurple = "_nb-a";
export var iconRed = "_nb-b";
export var iconWarning = "_nb-c";